import Content from "./Content";
import Parallax from "./Parallax";

const MovingAnimation = () => {
    return (
        <section className="MovingSection">
            <div className="firstLine">
                <Parallax baseVelocity={-5}>
                    <Content />
                </Parallax>
            </div>
        </section>
    );
};

export default MovingAnimation;
